export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14156.7de48355.jpg";